import type { ElementType, ReactNode } from 'react';

/**
 * The one shared focus affordance (§13). Add this class to any focusable
 * custom element instead of an ad-hoc `outline` rule; its sole effect is
 * `:focus-visible { box-shadow: var(--sh-focus) }` (defined in globals.css).
 */
export const focusRing = 'focus-ring';

interface FocusRingProps {
  as?: ElementType;
  className?: string;
  children?: ReactNode;
  [key: string]: unknown;
}

/** Thin wrapper that stamps the shared focus-ring class onto an element. */
export function FocusRing({ as: Tag = 'span', className, children, ...rest }: FocusRingProps) {
  const cls = className ? `${focusRing} ${className}` : focusRing;
  return (
    <Tag className={cls} {...rest}>
      {children}
    </Tag>
  );
}
